import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100 bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_2 = { class: "mb-10 text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Create an Account", -1)
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-4" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Sign in here ")
const _hoisted_7 = { class: "row fv-row mb-7" }
const _hoisted_8 = { class: "col-xl-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "First Name", -1)
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "col-xl-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Last Name", -1)
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "col-xl-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Company", -1)
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "row fv-row mb-7" }
const _hoisted_21 = { class: "col-xl-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Address", -1)
const _hoisted_23 = { class: "fv-plugins-message-container" }
const _hoisted_24 = { class: "fv-help-block" }
const _hoisted_25 = { class: "col-xl-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "City", -1)
const _hoisted_27 = { class: "fv-plugins-message-container" }
const _hoisted_28 = { class: "fv-help-block" }
const _hoisted_29 = { class: "col-xl-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "State/Province", -1)
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row fv-row mb-7" }
const _hoisted_34 = { class: "col-xl-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Zip/Postal Code", -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "col-xl-4" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Country", -1)
const _hoisted_40 = { class: "fv-plugins-message-container" }
const _hoisted_41 = { class: "fv-help-block" }
const _hoisted_42 = { class: "col-xl-4" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Phone", -1)
const _hoisted_44 = { class: "fv-plugins-message-container" }
const _hoisted_45 = { class: "fv-help-block" }
const _hoisted_46 = { class: "row fv-row mb-7" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Region for Assessment", -1)
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "fv-plugins-message-container" }
const _hoisted_50 = { class: "fv-help-block" }
const _hoisted_51 = { class: "fv-row mb-7" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Email", -1)
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "row fv-row mb-7" }
const _hoisted_56 = {
  class: "col-xl-6",
  "data-kt-password-meter": "true"
}
const _hoisted_57 = { class: "mb-1" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, " Password ", -1)
const _hoisted_59 = { class: "position-relative mb-3" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, " Use 8 or more characters with a mix of letters, numbers & symbols. ", -1)
const _hoisted_63 = { class: "col-xl-6" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 required" }, "Confirm Password", -1)
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "fv-row mb-7" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Referral Code", -1)
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "fv-row mb-7" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Comment", -1)
const _hoisted_73 = { class: "fv-plugins-message-container" }
const _hoisted_74 = { class: "fv-help-block" }
const _hoisted_75 = { class: "text-center" }
const _hoisted_76 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_79 = [
  _hoisted_77,
  _hoisted_78
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Recaptcha = _resolveComponent("Recaptcha")!
  const _component_globalFunctions = _resolveComponent("globalFunctions")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_register_signin_form",
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.register
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: "/sign-in",
              class: "link-primary fw-bolder"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideError('first_name'))),
              name: "first_name",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "first_name" })
                ]),
                (_ctx.errorsRef?.first_name)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.first_name, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideError('last_name'))),
              name: "last_name",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "last_name" })
                ]),
                (_ctx.errorsRef?.last_name)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.last_name, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideError('company'))),
              name: "company",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "company" })
                ]),
                (_ctx.errorsRef?.company)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.company, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hideError('address'))),
              placeholder: "",
              name: "address",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "address" })
                ]),
                (_ctx.errorsRef?.address)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.address, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideError('city'))),
              name: "city",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "city" })
                ]),
                (_ctx.errorsRef?.city)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.city, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideError('province'))),
              name: "province",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "province" })
                ]),
                (_ctx.errorsRef?.province)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.province, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "postal_code",
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.hideError('postal_code'))),
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "postal_code" })
                ]),
                (_ctx.errorsRef?.postal_code)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.postal_code, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "text",
              placeholder: "",
              name: "country",
              onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.hideError('country'))),
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "country" })
                ]),
                (_ctx.errorsRef?.country)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.country, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "tel",
              placeholder: "",
              name: "phone",
              onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.hideError('phone'))),
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "phone" })
                ]),
                (_ctx.errorsRef?.phone)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.phone, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _createVNode(_component_Field, {
            as: "select",
            name: "region",
            modelValue: _ctx.selectValue,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectValue) = $event)),
            onInput: _cache[10] || (_cache[10] = ($event: any) => (_ctx.hideError('region'))),
            class: "form-select form-select-solid form-select-lg fw-bold"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regions, (region, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: region.id,
                  key: i
                }, _toDisplayString(region.name), 9, _hoisted_48))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("p", null, [
                _createVNode(_component_ErrorMessage, { name: "region" })
              ]),
              (_ctx.errorsRef?.region)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.region, (error, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      role: "alert",
                      key: i
                    }, _toDisplayString(error), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "email",
            placeholder: "",
            name: "email",
            onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hideError('email'))),
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", null, [
                _createVNode(_component_ErrorMessage, { name: "email" })
              ]),
              (_ctx.errorsRef?.email)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.email, (error, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      role: "alert",
                      key: i
                    }, _toDisplayString(error), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _hoisted_58,
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "password",
                  placeholder: "",
                  name: "password",
                  onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.hideError('password'))),
                  autocomplete: "off"
                }),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_ErrorMessage, { name: "password" })
                    ]),
                    (_ctx.errorsRef?.password)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.password, (error, i) => {
                          return (_openBlock(), _createElementBlock("p", {
                            role: "alert",
                            key: i
                          }, _toDisplayString(error), 1))
                        }), 128))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _hoisted_62
          ]),
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "password",
              placeholder: "",
              onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.hideError('password_confirmation'))),
              name: "password_confirmation",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("p", null, [
                  _createVNode(_component_ErrorMessage, { name: "password_confirmation" })
                ]),
                (_ctx.errorsRef?.password_confirmation)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.password_confirmation, (error, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        role: "alert",
                        key: i
                      }, _toDisplayString(error), 1))
                    }), 128))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _hoisted_68,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            placeholder: "",
            name: "coupon",
            onInput: _cache[14] || (_cache[14] = ($event: any) => (_ctx.hideError('coupon'))),
            autocomplete: "off"
          }),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("p", null, [
                _createVNode(_component_ErrorMessage, { name: "coupon" })
              ]),
              (_ctx.errorsRef?.coupon)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.coupon, (error, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      role: "alert",
                      key: i
                    }, _toDisplayString(error), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_71, [
          _hoisted_72,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-solid",
            type: "text",
            placeholder: "",
            name: "comment",
            onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.hideError('comment'))),
            as: "textarea"
          }),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, [
              _createElementVNode("p", null, [
                _createVNode(_component_ErrorMessage, { name: "comment" })
              ]),
              (_ctx.errorsRef?.comment)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.errorsRef?.comment, (error, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      role: "alert",
                      key: i
                    }, _toDisplayString(error), 1))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode(_component_Recaptcha, { onRecaptchaValue: _ctx.setStatus }, null, 8, ["onRecaptchaValue"]),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("button", _hoisted_76, _hoisted_79, 512)
        ]),
        _createVNode(_component_globalFunctions, { onRegion: _ctx.getRegion }, null, 8, ["onRegion"])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}